import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Audio } from '../../../../../models/audio';
import { IconHelper } from '../../../../../utils/icon-helper';
import { BookAudioService } from '../../../../../services/book-audio.service';
import { AssetService } from '../../../../../services/asset.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalService } from '../../../../../services/modal.service';

@Component({
    selector: 'app-page-audio',
    templateUrl: './page-audio.component.html',
    styleUrls: ['./page-audio.component.scss'],
    standalone: true
})
export class PageAudioComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() audio: Audio;
    @ViewChild('audioPlayer') audioPlayer;
    icon: string;
    toggled = false;
    clickedOnce = false;
    playIcon: string;
    pauseIcon: string;
    showButtons = false;

    intervalId;

    constructor(
        private audioService: BookAudioService,
        private applicationStateService: ApplicationStateService,
        private modalService: ModalService,
        private assertService: AssetService) {
    }

    ngOnInit(): void {
        this.icon = IconHelper.getIconToShow(this.audio);
        this.playIcon = this.assertService.getUrl('link-modal/large-link-icon-audio-play.png');
        this.pauseIcon = this.assertService.getUrl('link-icon-audio-pause.png');
    }

    ngAfterViewInit(): void {

        this.intervalId = setInterval(() => {

            if (!this.showButtons && this.audioPlayer) {
                this.audioPlayer.nativeElement.load();
            } else {
                clearInterval(this.intervalId);
            }
        }, 1500);
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    onEnd(): void {
        this.toggled = false;
    }

    onCanPlay(): void {
        this.showButtons = true;
    }

    onAudioClicked($event): void {

        if ((!this.applicationStateService.bookConfig.bookPermissions.bookAudio.view ||
                !this.applicationStateService.userData.bookAccessCode) &&
            !this.audio.canBypassCheck()) {
            this.modalService.openModal(this.audio);

            return;
        }

        // prevents multiple logs
        if (!this.clickedOnce) {
            this.audioService.logUsage(this.audio);
            this.clickedOnce = true;
        }

        if (!this.audioPlayer) {
            console.error('There is no URL in the audio');

            return;
        }

        if (this.toggled) {
            this.audioPlayer.nativeElement.pause();
        } else {
            this.audioPlayer.nativeElement.play()
                .catch(err => {
                    console.error('Audio could not be played.');
                    this.audioPlayer.nativeElement.load();
                    this.audioPlayer.nativeElement.play();
                });
        }

        this.toggled = !this.toggled;
    }
}
